<template>
  <theme-card class="items-swiper" :class="`items-${gameKey}`" :title="title" :icon="icon" :id="id">
    <template #extra>
      <van-space class="header-tools">
        <span v-if="showLinkAll" @click="linkHandle">
          <button class="link-more theme-grey-btn">{{ $t('全部') }}</button>
        </span>
        <button class="backward theme-grey-btn">
          <van-icon class="svg-icon" name="arrow-left" />
        </button>
        <button class="forward theme-grey-btn">
          <van-icon class="svg-icon" name="arrow" />
        </button>
      </van-space>
    </template>
    <van-skeleton :loading="reqHomeGamesDataLoading">
      <template #template>
        <van-grid :border="false" :column-num="columnNum" :gutter="10">
          <van-grid-item v-for="value in skeletonImageNums" :key="value">
            <van-skeleton-image />
          </van-grid-item>
        </van-grid>
        <!--        <div class="flex-between" style="width: 100%">-->
        <!--          <van-skeleton-image />-->
        <!--          <van-skeleton-image />-->
        <!--          <van-skeleton-image />-->
        <!--        </div>-->
      </template>

      <swiper
        ref="swiperRef"
        :key="gameKey"
        :breakpoints="activeBreakpoints"
        :modules="[Navigation]"
        :navigation="{
          enabled: true,
          prevEl: `#${id} .backward`,
          nextEl: `#${id} .forward`,
          disabledClass: 'disabled',
        }"
        :touchRatio="1.5"
        :touchAngle="70"
        :space-between="11"
        :speed="400"
        v-if="items.length > 0 && props.mainType"
      >
        <swiper-slide v-if="mainType === GameMainTypesEnum.HOT_GAME && hotGamesPlatforms.length > 0">
          <swiper-item :items="hotGamesPlatforms" :group="mainType" :isHotPlatform="true" />
        </swiper-slide>
        <swiper-slide v-for="(item, i) in items" :key="i">
          <swiper-item :items="item" :group="mainType" />
        </swiper-slide>
      </swiper>
    </van-skeleton>
    <!--    <template v-else>-->
    <!--      -->
    <!--    </template>-->
  </theme-card>
  <hot-games v-model="hotGamesVisible" />
</template>

<script lang="ts" setup>
import { computed, onMounted, ref } from 'vue';

import { Navigation } from 'swiper/modules';
import SwiperItem from './SwiperItem.vue';
import { Swiper, SwiperSlide } from 'swiper/vue';
import 'swiper/css';
import { uuid } from '@star/utils';
import { chunk } from 'lodash-es';
import ThemeCard from '@/components/ThemeCard/index.vue';
import { bigTypeNameConfig, GameMainTypesEnum, gameMainTypesMap } from '@star/constants';
import HotGames from './HotGames.vue';
import { useRouter } from 'vue-router';
import { storeToRefs, useGameStore } from '@star/stores';
import { handleServerGameImg } from '@/plugins/game';

type Props = {
  // type?: 'game' | 'provider';
  mainType: GameMainTypesEnum;
  title: string;
  path: string;
  icon: string;
  items: any[];
  maxRows?: number; // 多行显示 1,2,3
  // cache?: boolean;
};

const props = withDefaults(defineProps<Props>(), {
  maxRows: 1,
});
// console.log(props, 'props');

// 游戏大类转换成菜单type
const bigTypeConfig = {
  1: 1, // 棋牌
  2: 3, // 电子
  3: 4, // 捕鱼
  4: 5, // 真人
  8: 2, // 彩票
};

// private String bg_img_url; //首页平台ICON
// private String thumbnail_img_url; //游戏列表ICON
// private String logo1_img_url; //首页热门icon
// private String logo2_img_url; //游戏TAB选中ICON
// private String logo3_img_url; //游戏TAB高亮ICON

const hotGamesPlatforms = computed(() => {
  if (!hotGamesPlatform.value) return [];
  let gameInfo = {};
  const bigType = hotGamesPlatform.value.big_type;
  const iconName = bigTypeNameConfig[bigType];
  gameInfo = {
    ...hotGamesPlatform.value,
    path: `/home/${bigTypeConfig[bigType]}/${hotGamesPlatform.value.play_id}`,
    colorImgSrc:
      handleServerGameImg(hotGamesPlatform.value.logo3_img_url) ||
      `/images/game/${iconName}/color_${hotGamesPlatform.value.play_id}.png`,
    gameImgUrl: handleServerGameImg(hotGamesPlatform.value.logo1_img_url),
    gameIndex: 0,
    mainType: bigTypeConfig[bigType],
    data: hotGamesPlatform.value,
  };
  return [gameInfo];
});

const router = useRouter();
const { reqHomeGamesDataLoading, hotGamesPlatform, gameMainClassList } = storeToRefs(useGameStore());
const id = `games-swiper-${uuid(32, 16)}`;
const swiperRef = ref();
const breakpoints = ref<Record<number, any>>({
  0: {
    slidesPerView: 3.2,
    slidesPerGroup: 3,
  },
  550: {
    slidesPerView: 3.2,
    slidesPerGroup: 3,
  },
});
const hotTGameBreakpoints = ref<Record<number, any>>({
  0: {
    slidesPerView: 2.2,
    slidesPerGroup: 2,
  },
  550: {
    slidesPerView: 2.2,
    slidesPerGroup: 2,
  },
});

const breakpointsLottery = ref<Record<number, any>>({
  0: {
    slidesPerView: 1.3,
    slidesPerGroup: 1,
  },
  550: {
    slidesPerView: 1.3,
    slidesPerGroup: 1,
  },
});
const hotGamesVisible = ref<boolean>(false);

const skeletonImageNums = computed(() => {
  if (props.mainType === GameMainTypesEnum.HOT_GAME) {
    return 4;
  } else if (props.mainType === GameMainTypesEnum.LOTTERY) {
    return 1;
  } else {
    return 3;
  }
});

const columnNum = computed(() => {
  if ([GameMainTypesEnum.HOT_GAME].includes(props.mainType)) {
    return 2;
  } else if ([GameMainTypesEnum.LOTTERY].includes(props.mainType)) {
    return 1;
  } else {
    return 3;
  }
});

const showLinkAll = computed(() => {
  if (props.mainType === GameMainTypesEnum.HOT_GAME) {
    return props.items && props.items.length > 6;
  } else {
    return props.items && props.items.length > 1;
  }
});

const activeBreakpoints = computed(() => {
  let _points = {};
  if (props.mainType === GameMainTypesEnum.HOT_GAME) {
    _points = hotTGameBreakpoints.value;
  } else if (props.mainType === GameMainTypesEnum.LOTTERY) {
    _points = breakpointsLottery.value;
  } else if (props.mainType === GameMainTypesEnum.ELECTRONIC) {
    _points = breakpoints.value;
  } else {
    _points = breakpoints.value;
  }
  console.log('props.mainType', props.mainType, props.title, props.mainType === GameMainTypesEnum.LOTTERY);
  return _points;
});

const gameKey = computed(() => {
  return gameMainTypesMap[props.mainType];
});

const items = computed(() => {
  // 热门不用排序
  const result = props.mainType == 10000 ? props.items : [...props.items].sort((a, b) => a.play_sort - b.play_sort);
  return chunk(result, props.maxRows);
});

const linkHandle = () => {
  console.log(props.path, 'props.path');
  if (props.mainType === GameMainTypesEnum.HOT_GAME) {
    hotGamesVisible.value = true;
  } else {
    router.push(props.path || '/');
  }
};

onMounted(async () => {});
</script>

<style lang="less" scoped>
.items-swiper {
  margin-top: 18px;

  .header-tools {
    button {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 63px;
      border-radius: 10px;
      cursor: pointer;

      &.link-more {
        font-size: 36px;
        padding: 0 24px;
        font-weight: 400;
        color: #a7a7a7;
        background: var(--theme-btn-default-background);
        border-color: var(--theme-btn-default-background);
      }

      .svg-icon {
        //transform: scale(1);
        transition: 0.2s;
        color: #999;
        font-weight: 600;
      }

      &[disabled] {
        cursor: not-allowed;

        .svg-icon {
          opacity: 0.2;
        }
      }

      &:hover:not(.disabled) {
        .svg-icon {
          //transform: scale(1.1);
          opacity: 1;
        }
      }

      &:active:not(.disabled) {
        .svg-icon {
          //transform: scale(0.86);
          opacity: 1;
        }
      }

      &.backward,
      &.forward {
        width: 61px;
        height: 63px;
        background: var(--theme-btn-default-background);
        border-color: var(--theme-btn-default-background);
      }
    }
  }

  .swiper {
    width: 100%;
    padding-top: 30px;

    .swiper-wrapper {
      .swiper-slide {
        height: 100%;

        :deep(.game-item) {
          + .game-item {
            margin-top: 33px;
          }
        }
      }
    }
  }

  .van-skeleton {
    padding: 0;
    margin-left: -15px;
    margin-right: -15px;

    :deep(.van-grid) {
      width: 100%;

      .van-grid-item__content {
        padding: 0;
      }
    }

    :deep(.van-skeleton-image) {
      width: 100%;
      height: 375px;
      border-radius: 60px;
    }
  }

  &.items-hotGame {
    .van-skeleton {
      :deep(.van-skeleton-image) {
        height: 260px;
        border-radius: 30px;
      }
    }

    :deep(.image-wrapper) {
      .van-image__error,
      .van-image__loading {
        background: transparent;
      }
    }
  }

  &.items-lottery {
    :deep(.van-grid) {
      width: 70%;
    }

    .van-skeleton {
      :deep(.van-skeleton-image) {
        height: 300px;
        border-radius: 30px;
      }
    }
  }
}

// @media screen and (max-width: 768px) {
// }
</style>
